export interface AppointmentTypeOption {
  key: string;
  label: string;
  backgroundColor: string;
  color: string;
  // read by NotificationList's tab rendering (`tab.badge`) but never set here — dead branch, kept as-is
  badge?: string;
}

export const AppointmentTypes: AppointmentTypeOption[] = [
  { key: 'GENERAL', label: 'General', backgroundColor: '#E8F4F8', color: '#0097A7' },
  { key: 'APPOINTMENT_REMINDER', label: 'Reminder', backgroundColor: '#FFF3E0', color: '#F57C00'},
  { key: 'APPOINTMENT_CANCELED', label: 'Cancelled', backgroundColor: '#FFEBEE', color: '#C62828'},
  { key: 'APPOINTMENT_UPDATED', label: 'Updated', backgroundColor: '#E8F5E9', color: '#388E3C'},
];
